/**
 * The speaker body every volume glyph is built on: the cone-and-box outline,
 * drawn once here so the volume icons differ only in the detail that rides
 * to their right and never drift apart.
 *
 * The path is drawn on the 24 grid toward the left (x 3 -> 12.75), leaving
 * the right third for that detail: a box rounded almost into a pill, and a
 * cone widening from it, every corner of the outline rounded.
 * `SPEAKER_CENTERING_SHIFT` slides it to the middle of the canvas for a
 * glyph that carries no detail, which would otherwise sit conspicuously
 * off-center.
 *
 * Stroke styling (color, width, caps) comes from the enclosing group, so a
 * caller can paint the body from a different palette slot than its detail.
 */import*as React from"react";import roundedPolygon from"web/shared/icons/glyphs/roundedPolygon";// How far right the body slides when it is alone on the canvas.
import{jsx as _jsx}from"react/jsx-runtime";export const SPEAKER_CENTERING_SHIFT=4.5;// Where a detail sits beside the body: the wave arcs' shared origin, the
// sign's center line, and the vertical middle of the canvas.
export const DETAIL_CENTER_X=19;export const DETAIL_CENTER_Y=12;// The outline's corners, clockwise from the box's top-left: the box's two
// left corners, where its top meets the cone, the cone's two tips, and
// where the cone meets the box's bottom.
const SPEAKER_CORNERS=[{x:3,y:9},{x:7,y:9},{x:12.75,y:4},{x:12.75,y:20},{x:7,y:15},{x:3,y:15}];// How far back from each corner its curve begins, all of them broad: the
// box's corners and the bends into the cone each take half the box's short
// top edge, so that edge is curve end to end, and the cone's tips round
// across half its slanted edge.
const BOX_ROUNDING=2;const TIP_ROUNDING=4;const BEND_ROUNDING=2;const ROUNDINGS=[BOX_ROUNDING,BEND_ROUNDING,TIP_ROUNDING,TIP_ROUNDING,BEND_ROUNDING,BOX_ROUNDING];const SPEAKER_PATH=roundedPolygon(SPEAKER_CORNERS,index=>ROUNDINGS[index]);function SpeakerBase(){return/*#__PURE__*/_jsx("path",{d:SPEAKER_PATH});}export default SpeakerBase;